// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordered-selector-container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;

  display: flex;
  flex-direction: row;
  gap: 2rem;
}

.all-items-list {
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  padding-bottom: 1rem;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.1rem;
  margin-right: 1rem;
  user-select: none;
  border-radius: 0.5rem;
  padding: 1rem 0;
  cursor: grab;
}

.list-item:hover {
  transition: 0.3s;
  background: #f0f0f0;
}

.list-item:active {
  background: rgba(27, 26, 26, 0.247)
}

.list-item-order {
  width: 2rem;
}

.list-item-name {
  flex: 1 1 40rem;
  text-align: left;
  margin: 0 1rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.list-item-image {
  width: 2.6rem;
  height: 2.6rem;
  margin-left: .5rem;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  -webkit-user-drag: none;
}

.order-controls {
  width: 10rem;
  display: flex;
  flex-direction: row;
}

.order-control-icon {
  color: #979797;
  margin: 0 0.5rem 0 1rem;
  width: 20px;
  height: 20px;
  display: flex;
  scale: 2;
}

.order-control-icon:not(.disabled) {
  cursor: pointer;
  color: #26a69a;
}

.order-control-icon:not(.disabled):hover {
  scale: 2.2;
  transition: color 0.3s, scale 0.3s;
  color: #1a7068;
}

.list-item.dragging {
  opacity: 0.5;
  background-color: #f0f0f0;
  cursor: grabbing;
}




.list-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.all-items-list {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/OrderedChannelsSelector/OrderedChannelsSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;;EAEtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;;;;AAKA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ordered-selector-container {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: 100%;\r\n  max-height: 100%;\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 2rem;\r\n}\r\n\r\n.all-items-list {\r\n  height: 100%;\r\n  max-height: 100%;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.list-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: 3.1rem;\r\n  margin-right: 1rem;\r\n  user-select: none;\r\n  border-radius: 0.5rem;\r\n  padding: 1rem 0;\r\n  cursor: grab;\r\n}\r\n\r\n.list-item:hover {\r\n  transition: 0.3s;\r\n  background: #f0f0f0;\r\n}\r\n\r\n.list-item:active {\r\n  background: rgba(27, 26, 26, 0.247)\r\n}\r\n\r\n.list-item-order {\r\n  width: 2rem;\r\n}\r\n\r\n.list-item-name {\r\n  flex: 1 1 40rem;\r\n  text-align: left;\r\n  margin: 0 1rem;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.list-item-image {\r\n  width: 2.6rem;\r\n  height: 2.6rem;\r\n  margin-left: .5rem;\r\n  margin-top: 0.1rem;\r\n  margin-bottom: 0.1rem;\r\n  -webkit-user-drag: none;\r\n}\r\n\r\n.order-controls {\r\n  width: 10rem;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.order-control-icon {\r\n  color: #979797;\r\n  margin: 0 0.5rem 0 1rem;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  scale: 2;\r\n}\r\n\r\n.order-control-icon:not(.disabled) {\r\n  cursor: pointer;\r\n  color: #26a69a;\r\n}\r\n\r\n.order-control-icon:not(.disabled):hover {\r\n  scale: 2.2;\r\n  transition: color 0.3s, scale 0.3s;\r\n  color: #1a7068;\r\n}\r\n\r\n.list-item.dragging {\r\n  opacity: 0.5;\r\n  background-color: #f0f0f0;\r\n  cursor: grabbing;\r\n}\r\n\r\n\r\n\r\n\r\n.list-container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.all-items-list {\r\n  width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
